import React from 'react';
import QuestionAdvancedOptions from './QuestionAdvancedOptions';
import AnswerAdvancedOptions from './AnswerAdvancedOptions';
import CommentAdvancedOptions from './CommentAdvancedOptions';
import {COLOR_FIELDS} from '../../../common/fontAndBackgroundColorPicker';
import {ELEMENT} from '../../../../../../incase-domain/elements/base/ElementTypes';
import {IQuestionElements} from '../../../../../../incase-domain/elements/question';

interface AdvancedOptionsProps {
    highlightedElement: IQuestionElements;
    highlightedElementChangeHandler: {
        single: (field: keyof IQuestionElements | string, value: unknown) => void;
        multiple: (fields: (keyof IQuestionElements)[], values: unknown[]) => void;
    };
    answerColorFields?: COLOR_FIELDS[];
    commentColorFields?: COLOR_FIELDS[];
}

export default function AdvancedOptions(props: AdvancedOptionsProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler, answerColorFields, commentColorFields} = props;

    return (
        <div className="l-group__item">
            <QuestionAdvancedOptions
                highlightedElement={highlightedElement}
                highlightedElementChangeHandler={highlightedElementChangeHandler}
            />
            {highlightedElement.type !== ELEMENT.IMAGE_MARKUP && answerColorFields && (
                <AnswerAdvancedOptions
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={highlightedElementChangeHandler}
                    answerColorFields={answerColorFields}
                />
            )}
            {highlightedElement.type !== ELEMENT.IMAGE_MARKUP && commentColorFields && (
                <CommentAdvancedOptions
                    highlightedElement={highlightedElement}
                    highlightedElementChangeHandler={highlightedElementChangeHandler}
                    commentColorFields={commentColorFields}
                />
            )}
        </div>
    );
}
